var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "assistance" },
    [
      _c(
        "ic-form-row-horizontal2",
        {
          attrs: {
            aria: "Pole jest wymagane",
            label: "W obrębie dworca do/od drzwi pociągu",
            new_id: "atStation",
            labelWidth: 4,
            controlWidth: 8,
            error: _vm.hasError("form.assistance.atStation"),
            required: _vm.isRequired("form.assistance.atStation"),
          },
        },
        [
          _c("ic-checkbox-group", {
            attrs: {
              id: "atStation",
              options: _vm.assistanceAtStationTypes,
              v: _vm.v.form.assistance.atStation,
              allowEmpty: false,
            },
            model: {
              value: _vm.assistance.atStation,
              callback: function ($$v) {
                _vm.$set(_vm.assistance, "atStation", $$v)
              },
              expression: "assistance.atStation",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "row g-3" }, [
            _c("div", { staticClass: "col-sm-8 offset-sm-4" }, [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("assistance_at_station_conditions")),
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "ic-form-row-horizontal2",
            {
              attrs: {
                new_id: "atStationRemarks",
                labelWidth: 4,
                controlWidth: 8,
                label: "Dodatkowe informacje dotyczące asysty w obrębie dworca",
              },
            },
            [
              _c("ic-textarea", {
                attrs: {
                  id: "atStationRemarks",
                  placeholder:
                    "np. będzie potrzebny wózek inwalidzki będący na wyposażeniu PKP S.A. albo pomoc będzie potrzebna na wybranych stacjach, tj. A, B i C",
                  "aria-labelledby": "atStationRemarks_label",
                },
                model: {
                  value: _vm.assistance.atStationRemarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.assistance, "atStationRemarks", $$v)
                  },
                  expression: "assistance.atStationRemarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ic-form-row-horizontal2",
        {
          attrs: {
            aria: "Pole jest wymagane",
            label: "Pomoc w pociągu",
            new_id: "inTrain",
            labelWidth: 4,
            controlWidth: 8,
            error: _vm.hasError("form.assistance.inTrain"),
            required: _vm.isRequired("form.assistance.inTrain"),
          },
        },
        [
          _c("ic-checkbox-group", {
            attrs: {
              id: "inTrain",
              options: _vm.assistanceInTrainTypes,
              multiple: true,
              v: _vm.v.form.assistance.inTrain,
              placeholder:
                "... (Wybierz jedną lub kilka z " +
                _vm.assistanceInTrainTypes.length +
                " opcji)",
              allowEmpty: false,
            },
            model: {
              value: _vm.assistance.inTrain,
              callback: function ($$v) {
                _vm.$set(_vm.assistance, "inTrain", $$v)
              },
              expression: "assistance.inTrain",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row g-3" }, [
        _c("div", { staticClass: "col-sm-8 offset-sm-4" }, [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("assistance_in_train_conditions")),
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "ic-form-row-horizontal2",
        {
          attrs: {
            aria: "Pole jest wymagane",
            label: "Bagaż podręczny",
            new_id: "baggage",
            labelWidth: 4,
            controlWidth: 8,
            error: _vm.hasError("form.assistance.baggage"),
            required: _vm.isRequired("form.assistance.baggage"),
          },
        },
        [
          _c("ic-checkbox-group", {
            attrs: {
              id: "baggage",
              options: _vm.assistanceBaggageTypes,
              multiple: true,
              v: _vm.v.form.assistance.baggage,
              placeholder:
                "... (Wybierz jedną lub kilka z " +
                _vm.assistanceBaggageTypes.length +
                " opcji)",
              allowEmpty: false,
            },
            model: {
              value: _vm.assistance.baggage,
              callback: function ($$v) {
                _vm.$set(_vm.assistance, "baggage", $$v)
              },
              expression: "assistance.baggage",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.assistance.baggage.length && _vm.assistance.baggage[0] != "na"
        ? _c(
            "ic-form-row-horizontal2",
            {
              attrs: {
                new_id: "size",
                error: _vm.hasError("form.assistance.baggage_size"),
                label: " ",
                labelWidth: 4,
                controlWidth: 8,
              },
            },
            [
              _c(
                "ic-checkbox",
                {
                  attrs: {
                    id: "baggage_size",
                    aria: "Pole jest wymagane",
                    val: 1,
                    v: _vm.v.form.assistance.baggage_size,
                  },
                  model: {
                    value: _vm.assistance.baggage_size,
                    callback: function ($$v) {
                      _vm.$set(_vm.assistance, "baggage_size", $$v)
                    },
                    expression: "assistance.baggage_size",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("baggage_size_description")) + " *"
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ic-form-row-horizontal2",
        {
          attrs: {
            aria: "Pole jest wymagane",
            label: "Miejsce spotkania",
            new_id: "meetingPlace",
            labelWidth: 4,
            controlWidth: 8,
            error: _vm.hasError("form.assistance.meetingPlace"),
            required: _vm.isRequired("form.assistance.meetingPlace"),
          },
        },
        [
          _c("ic-select-system", {
            attrs: {
              id: "meetingPlace",
              values: _vm.meetingPlaceTypes,
              v: _vm.v.form.assistance.meetingPlace,
              placeholder: "... (Wybierz jedną z opcji)",
              allowEmpty: false,
            },
            model: {
              value: _vm.assistance.meetingPlace,
              callback: function ($$v) {
                _vm.$set(_vm.assistance, "meetingPlace", $$v)
              },
              expression: "assistance.meetingPlace",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.assistance.meetingPlace == "prm"
        ? _c(
            "ic-form-row-horizontal2",
            { attrs: { new_id: "prmImage", labelWidth: 4, controlWidth: 8 } },
            [
              _c("p", [
                _vm._v("Sprawdź "),
                _c(
                  "a",
                  {
                    attrs: { href: "https://www.pkp.pl/pl/bez-barier" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.oznStations.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("wykaz dworców")]
                ),
                _vm._v(", na których wyznaczono miejsca spotkań."),
              ]),
              _vm._v(" "),
              _c("p", { attrs: { "aria-hidden": "true" } }, [
                _vm._v(
                  "Rysunek przedstawiający tablicę miejsca wyznaczonego do spotkań osoby z niepełnosprawnością z asystą na dworcu."
                ),
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "img-responsive",
                attrs: {
                  src: "/ax26hrxl857-a/components/icformozn/img/baner_bottom_form_ozn1.jpg",
                  alt: "Rysunek przedstawiający wygląd oznaczenia miejsca oczekiwania dla osób z niepełnosprawnością ruchową",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.assistance.meetingPlace === "other"
        ? _c(
            "ic-form-row-horizontal2",
            {
              attrs: {
                new_id: "meetingPlaceOther",
                labelWidth: 4,
                controlWidth: 8,
                error: _vm.hasError("form.assistance.meetingPlaceOther"),
                required: _vm.isRequired("form.assistance.meetingPlaceOther"),
              },
            },
            [
              _c("label", { attrs: { for: "meetingPlaceOther" } }, [
                _vm._v("Proszę napisać:"),
              ]),
              _vm._v(" "),
              _c("ic-textarea", {
                attrs: {
                  id: "meetingPlaceOther",
                  v: _vm.v.form.assistance.meetingPlaceOther,
                },
                model: {
                  value: _vm.assistance.meetingPlaceOther,
                  callback: function ($$v) {
                    _vm.$set(_vm.assistance, "meetingPlaceOther", $$v)
                  },
                  expression: "assistance.meetingPlaceOther",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }